import type { SettingState } from './types'

export const state: SettingState = {
  settings: [],
}
